import React, { useEffect } from 'react'
import ReactGA from 'react-ga'

ReactGA.initialize('UA-161006710-1')

export const withTracker = (WrappedComponent, options = {}) => {
    const trackPage = page => {
        ReactGA.set({
            page,
            ...options,
        })
        ReactGA.pageview(page)
    }

    const HOC = props => {
        useEffect(() => trackPage(props.location.pathname), [
            props.location.pathname,
        ])

        return <WrappedComponent {...props} />
    }

    return HOC
}
